"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const headerBlockInputs = [
  {
    name: "header",
    friendlyName: "Title",
    type: "string",
    required: true,
    defaultValue: "Ploom Club",
  },
  {
    name: "text",
    friendlyName: "Description",
    type: "richText",
    required: true,
    defaultValue:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    name: "componentId",
    type: "string",
  },
] as const satisfies Inputs;

export const HeaderBlockComponent: RegisteredComponent = {
  name: "HeaderBlock",
  component: dynamic(async () =>
    withValidation(headerBlockInputs, (await import("./HeaderBlock")).HeaderBlock, "HeaderBlock")
  ),
  inputs: headerBlockInputs,
};
